/* eslint-disable react-hooks/exhaustive-deps */
import Axios from "axios"
import { Formik } from "formik"
import { useEffect, useState } from "react"
import { Card, Col, Row } from "react-bootstrap"
import { useHistory, useParams } from "react-router-dom"
import * as Yup from "yup"
import { PengembalianBarangApi } from "../../../../api"
import {
  ActionButton,
  Alert,
  BackButton,
  CRUDLayout,
  DataStatus,
  Input,
  TBody,
  Td,
  TdFixed,
  Th,
  THead,
  ThFixed,
  Tr
} from "../../../../components"
import { DateConvert } from "../../../../utilities"

const EditPengembalianBarang = ({ setNavbarTitle }) => {
  // indikator pemanggilan data sedang dimuat di server (loading)
  const [isLoading, setIsLoading] = useState(true);

  const history = useHistory();

  // data
  const [data, setData] = useState([]);
  // menampung data yang akan dihapus

  // menampilkan alert
  const [showAlert, setShowAlert] = useState(false);
  // configurasi alert
  const [alertConfig, setAlertConfig] = useState({
    variant: "primary",
    text: "",
    status: false,
  });

  const { id } = useParams();

  // request data dari server
  const getData = () => {
    setIsLoading(true);
    Axios.all([PengembalianBarangApi.getFormEdit(id)])
      .then(
        Axios.spread((res) => {
          setData(res.data.data);
        })
      )
      .catch(() => {
        setAlertConfig({
          variant: "danger",
          text: "Data gagal dimuat",
        });
        setShowAlert(true);
      })
      .finally(() => setIsLoading(false));
  };

  useEffect(() => {
    // set Judul di Navbar
    setNavbarTitle("Pengembalian Barang");

    // jalankan function request data ke server
    getData();
    return () => {
      setIsLoading(false);
    };
  }, [setNavbarTitle]);

  const TambahData = () => {
    const [isNomorLoading, setIsNomorLoading] = useState(false);
    const [kode, setKode] = useState("");

    const getNomor = (value, setFieldValue) => {
      setIsNomorLoading(true);

      PengembalianBarangApi.getKode(value)
        .then(({ data }) => {
          setKode(data.data);
          setFieldValue("no_delivery_order", data.data);
        })
        .catch((err) => alert("Gagal mengambil nomor delivery order"))
        .finally(() => setIsNomorLoading(false));
    };

    const formInitialValues = {
      id_pengembalian_barang: id,
      tgl_pengembalian_barang: data.tgl_pengembalian_barang,
      no_pengembalian_barang: data.no_pengembalian_barang,
    };

    const formValidationSchema = Yup.object().shape({
      tgl_pengembalian_barang: Yup.string().required("Masukan tanggal pengembalian barang "),
    });

    // KIRIM DATA BARU KE SERVER
    const formSubmitHandler = (values) => {
      PengembalianBarangApi.update(values)
        .then(() => {
          history.push("/inventory/transaksi/pengembalian-barang", {
            variant: "primary",
            text: "Data berhasil di ubah",
            status: true,
          });
        })
        .catch((err) => {
          history.push("/inventory/transaksi/pengembalian-barang", {
            variant: "danger",
            text: `Tambah data gagal! (${err.response.data.message})`,
          });
        })
        .finally(() => {
          setIsLoading(false);
        });
    };

    const ShowData = ({ title, text }) => (
      <div className="d-flex flex-row">
        <div className="text-secondary mb-2 mr-3" style={{ width: 170 }}>
          <span style={{ textTransform: "capitalize" }}>{title}</span>
        </div>
        <span>:</span>
        <div
          className="text-dark"
          style={{
            fontWeight: 200,
            paddingLeft: 40,
          }}
        >
          {text ? text : "-"}
        </div>
      </div>
    );

    return (
      <>
        <Row>
          <Col lg="6">
            <ShowData
              title="Tgl. pembatalan faktur"
              text={DateConvert(new Date(data.tgl_pembatalan_faktur)).detail}
            />
          </Col>
          <Col lg="6">
            <ShowData title="No. pembatalan faktur" text={data.no_pembatalan_faktur} />
          </Col>
        </Row>
        <Row>
          <Col lg="6">
            <ShowData
              title="Tgl. faktur penjualan"
              text={DateConvert(new Date(data.tgl_faktur)).detail}
            />
          </Col>
          <Col lg="6">
            <ShowData title="No. faktur penjualan" text={data.no_faktur} />
          </Col>
        </Row>
        <Row>
          <Col lg="6">
            <ShowData
              title="Tgl. delivery order"
              text={DateConvert(new Date(data.tgl_delivery_order)).detail}
            />
          </Col>
          <Col lg="6">
            <ShowData title="No. delivery order" text={data.no_delivery_order} />
          </Col>
        </Row>
        <div className="my-3">
          <Col lg="12 pl-0">
            <ShowData title="Customer" text={data.nama_customer} />
          </Col>
          <Col lg="12 pl-0">
            <ShowData title="Sales" text={data.nama_sales} />
          </Col>
        </div>
        <hr />
        <Formik
          initialValues={formInitialValues}
          validationSchema={formValidationSchema}
          onSubmit={formSubmitHandler}
        >
          {({
            values,
            errors,
            touched,
            isSubmitting,
            setFieldValue,
            handleChange,
            handleSubmit,
          }) => (
            <form onSubmit={handleSubmit}>
              <Row>
                <Col lg="6">
                  <Input
                    label="Tanggal pengembalian barang"
                    type="date"
                    name="tgl_pengembalian_barang"
                    value={values.tgl_pengembalian_barang}
                    onChange={(e) => {
                      const value = e.target.value;

                      setFieldValue("tgl_pengembalian_barang", value);
                      getNomor(value, setFieldValue);
                    }}
                    error={
                      errors.tgl_pengembalian_barang && touched.tgl_pengembalian_barang && true
                    }
                    errorText={errors.tgl_pengembalian_barang}
                  />
                </Col>
                <Col lg="6">
                  <Input
                    label="No. pengembalian barang"
                    type="text"
                    name="no_pengembalian_barang"
                    value={values.no_pengembalian_barang}
                    placeholder={
                      isNomorLoading
                        ? "Memuat . . . "
                        : values.tgl_pengembalian_barang
                          ? kode
                          : "Pilih tanggal terlebih dahulu"
                    }
                    readOnly={true}
                    onChange={(e) => {
                      setFieldValue("no_pengembalian_barang", e.target.value);
                    }}
                    error={errors.no_pengembalian_barang && touched.no_pengembalian_barang && true}
                    errorText={errors.no_pengembalian_barang}
                  />
                </Col>
              </Row>
              <div className="mb-4"></div>
              <CRUDLayout.Table>
                <THead>
                  <Tr className="text-center">
                    <ThFixed>No</ThFixed>
                    <Th>Kode barang</Th>
                    <Th>Nama barang</Th>
                    <Th>Gudang</Th>
                    <Th>Qty SO</Th>
                    <Th>Satuan</Th>
                    <Th>Pengembalian</Th>
                  </Tr>
                </THead>
                <TBody>
                  {data?.detail?.map((val, index) => (
                    <Tr key={index}>
                      <TdFixed>{index + 1}</TdFixed>
                      <TdFixed>{val.kode_item}</TdFixed>
                      <Td>{val.nama_item}</Td>
                      <Td>{val.nama_gudang}</Td>
                      <Td>{val.qty}</Td>
                      <Td>{val.nama_satuan}</Td>
                      <Td>{val.qty_pengembalian}</Td>
                    </Tr>
                  ))}
                </TBody>
              </CRUDLayout.Table>
              <div className="d-flex justify-content-end">
                <ActionButton
                  type="submit"
                  variant="primary"
                  text="Simpan"
                  className="mt-2 px-4"
                  loading={isSubmitting}
                />
              </div>
            </form>
          )}
        </Formik>
      </>
    );
  };

  return (
    <Card>
      <Card.Header className="d-flex flex-row justify-content-between">
        <span>Edit Pengembalian Barang</span>

        <BackButton
          onClick={() => {
            history.goBack();
          }}
        />
      </Card.Header>
      <Card.Body>
        <Alert
          show={showAlert}
          showCloseButton={true}
          variant={alertConfig.variant}
          text={alertConfig.text}
          onClose={() => setShowAlert(false)}
        />
        {isLoading === true ? (
          <DataStatus loading={true} text="Memuat data..." />
        ) : data !== undefined ? (
          <TambahData />
        ) : (
          <DataStatus text="Tidak ada data" />
        )}
      </Card.Body>
    </Card>
  );
};

export default EditPengembalianBarang;
